import { event } from '@ice/stark-data';
import { useDebounceFn } from 'ahooks';
import { useEffect, useRef, useState } from 'react';
import { hookHistory } from 'src/utils';
import { getScript } from 'src/utils/async-load';
import { REFRESH_ALL_KEY } from 'src/utils/const';
import { imgPreview } from 'src/utils/dom';
export function useImgPreviewByRef(ref, content) {
    useEffect(() => {
        const imgList = [];
        const onImgClick = (e) => {
            const img = e.target;
            const imgUrls = imgList.map((img) => img.src);
            const newImgList = [
                img.src,
                ...imgUrls.filter((item) => item !== img.src),
            ];
            imgPreview(newImgList);
        };
        let onRemove = () => { };
        let isRemove = false;
        setTimeout(() => {
            const dom = ref.current;
            if (!dom)
                return;
            if (isRemove)
                return;
            imgList.push(...Array.from(dom.querySelectorAll('img')).filter((img) => img.src));
            imgList.forEach((img) => {
                img.addEventListener('click', onImgClick);
            });
            onRemove = () => {
                imgList.forEach((img) => {
                    img.removeEventListener('click', onImgClick);
                });
            };
        }, 100);
        return () => {
            isRemove = true;
            onRemove();
        };
    }, [ref, content]);
}
const CangjieResourceList = [
    {
        name: 'Cangjie',
        url: 'https://g.alicdn.com/code/npm/@ali/4ever-cangjie/1.47.0/index.js',
        promise: null,
    },
    {
        name: 'CangjieMo',
        url: 'https://g.alicdn.com/code/npm/@ali/4ever-mo/1.47.0/index.js',
        promise: null,
    },
    {
        name: 'CangjieZhi',
        url: 'https://g.alicdn.com/code/npm/@ali/4ever-zhi/1.47.0/index.js',
        promise: null,
    },
];
export function useDingRichEditor() {
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        const init = async () => {
            for (let item of CangjieResourceList) {
                // @ts-ignore 
                if (!window[item.name]) {
                    if (!item.promise) {
                        item.promise = getScript(item.url);
                    }
                    await item.promise;
                }
            }
            // console.log('window.Cangjie', window.Cangjie);
            // console.log('window.CangjieMo', window.CangjieMo);
            setLoaded(true);
        };
        init();
    }, []);
    return loaded;
}
export function useRender(render) {
    const ref = useRef(render);
    ref.current = render;
    return (param) => ref.current?.(param);
}
export function useInputOnSearch(search) {
    const stopSearchRef = useRef(false);
    const { run: onSearch } = useDebounceFn(search || (() => { }), {
        wait: 200,
        maxWait: 1000
    });
    if (!search) {
        return {};
    }
    return {
        onChange(val) {
            if (stopSearchRef.current)
                return;
            onSearch(val);
        },
        onCompositionStart() {
            stopSearchRef.current = true;
        },
        onCompositionEnd(e) {
            stopSearchRef.current = false;
            onSearch(e.target.value);
        }
    };
}
export function useMonitorHistory(callback) {
    useEffect(() => {
        const event = hookHistory();
        event.on(callback);
        return () => {
            event.off(callback);
        };
    }, [callback]);
}
export function useAllEvent(fn) {
    useEffect(() => {
        if (fn) {
            event(REFRESH_ALL_KEY, fn);
            return () => {
                event(REFRESH_ALL_KEY, fn);
            };
        }
    }, []);
    return;
}
